import { render } from "./PassengerTripTag.vue?vue&type=template&id=23a89bbc&scoped=true"
import script from "./PassengerTripTag.vue?vue&type=script&lang=js"
export * from "./PassengerTripTag.vue?vue&type=script&lang=js"

import "./PassengerTripTag.vue?vue&type=style&index=0&id=23a89bbc&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a89bbc"]])

export default __exports__